import classNames from "classnames";

const Slider = ({ value, marks, options, onClick, disabled = false }) => {
  return (
    <div className={classNames("b2c-slider__wrapper", { disabled })}>
      {marks.map((mark, index) => (
        <div
          onClick={() => !disabled && onClick(mark)}
          className={classNames("b2c-slider__option", {
            active: mark === value,
          })}
          key={`option-${index}`}
        >
          {options[mark]}
        </div>
      ))}
    </div>
  );
};

export default Slider;
